import { render, staticRenderFns } from "./pricePct.vue?vue&type=template&id=1e064523&"
import script from "./pricePct.vue?vue&type=script&lang=js&"
export * from "./pricePct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports